// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"styles_dropdown__2313Q","header":"styles_header__11PQU","list":"styles_list__3CHW3","item":"styles_item__3PR-9"};